<template>
  <v-app>
    <v-navigation-drawer app clipped fixed v-model="drawer" v-if="workspaceExists">
      <Navigation />
    </v-navigation-drawer>
    <v-app-bar app color="primary" clipped-left>
      <v-app-bar-nav-icon
        v-if="currentDefined"
        @click.stop="drawer = !drawer"
      ></v-app-bar-nav-icon>

      <div class="d-flex align-center mr-3">
        <v-img
          alt="Khata logo"
          class="shrink mr-2"
          contain
          src="@/assets/books.png"
          transition="scale-transition"
          width="40"
        />
        <div class="text-h4 text-white">Khata</div>
      </div>
      <v-btn small @click="showTransactionForm()" v-if="currentDefined">
        <v-icon small>mdi-plus-thick</v-icon>Add
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn dark text @click="onLogout" v-if="currentDefined">
        {{workspaceName | truncate15}}
        <v-icon large>mdi-logout</v-icon> 
      </v-btn>
    </v-app-bar>

    <v-main>
      <v-container fluid class="py-0">
        <v-container class="my-0 py-0" v-if="currentDefined">
          <v-scroll-y-transition mode="out-in">
            <router-view></router-view>
          </v-scroll-y-transition>
        </v-container>
        <v-container v-if="!currentDefined">
          <WorkspaceHome/>
        </v-container>
      </v-container>
      <transaction-form 
        :show.sync="transactionFormVisible"
        />
      <v-dialog v-model="error" persistent max-width="290">
        <v-card>
          <v-card-title class="headline"> Error </v-card-title>
          <v-card-text>
            <p>An error occured.</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="onClose()"> Close </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <Notification />
    </v-main>
  </v-app>
</template>

<script>
import { mdiLogout } from "@mdi/js";
import Navigation from "@/components/Navigation.vue";
import WorkspaceHome from "@/components/WorkspaceHome.vue"
import * as Cmd from "./Cmd"
import TransactionForm from './components/TransactionForm.vue';
import Notification from '@/components/common/Notification.vue';

export default {
  name: "App",

  components: {
    Navigation,
    WorkspaceHome,
    TransactionForm,
    Notification,
  },
  async created() {
    Cmd.init();
    await this.$store.dispatch("getWorkspaces");
  },
  data: () => ({
    icons: {mdiLogout},
    drawer: false,
    menu: false,
    currentActive: false,
    transactionFormVisible: false,
  }),
  computed: {
    error() {
      return this.$store.state.actionError;
    },
    currentDefined() {
      return this.$store.state.currentWorkspace !== undefined;
    },
    workspaceName() {
      return this.$store.state.currentWorkspace.name;
    },
    workspaceExists() {
      return this.$store.state.workspaces.length > 0;
    }
  },
  watch: {
    currentDefined () {
      if (!this.currentDefined) {
        this.drawer = false;
      }
    },
  }, 
  methods: {
    showTransactionForm() {
      this.transactionFormVisible = true;
    },
    hideTransactionForm() {
      this.transactionFormVisible = false;
    },
    onLogout() {
      this.$store.dispatch("logoutWorkspace");
      if (this.$router.currentRoute.path !== "/") {
        this.$router.push("/");
      }
    },
    async onClose() {
      await this.$store.dispatch("clearError");
    },
  },
};
</script>
